export const HttpHeadersToIgnoreValuesOfLc = new Set<string>([
		"Accept",
		"Accept-Additions",
		"Accept-CH",
		"Accept-Charset",
		"Accept-Datetime",
		"Accept-Encoding",
		"Accept-Features",
		"Accept-Language",
		"Accept-Patch",
		"Accept-Post",
		"Accept-Ranges",
		"Accept-Signature",
		"Access-Control",
		"Access-Control-Allow-Credentials",
		"Access-Control-Allow-Headers",
		"Access-Control-Allow-Methods",
		"Access-Control-Allow-Origin",
		"Access-Control-Expose-Headers",
		"Access-Control-Max-Age",
		"Access-Control-Request-Headers",
		"Access-Control-Request-Method",
		"Content-Type",
		"Content-Version",
		"User-Agent"
	].map( s => s.toLocaleLowerCase() )
);


export const StandardHttpHeaderNamesMixedCase = new Set([
"A-IM",
"Accept",
"Accept-Additions",
"Accept-CH",
"Accept-Charset",
"Accept-Datetime",
"Accept-Encoding",
"Accept-Features",
"Accept-Language",
"Accept-Patch",
"Accept-Post",
"Accept-Ranges",
"Accept-Signature",
"Access-Control",
"Access-Control-Allow-Credentials",
"Access-Control-Allow-Headers",
"Access-Control-Allow-Methods",
"Access-Control-Allow-Origin",
"Access-Control-Expose-Headers",
"Access-Control-Max-Age",
"Access-Control-Request-Headers",
"Access-Control-Request-Method",
"Age",
"Allow",
"ALPN",
"Alt-Svc",
"Alt-Used",
"Alternates",
"AMP-Cache-Transform",
"Apply-To-Redirect-Ref",
"Authentication-Control",
"Authentication-Info",
"Authorization",
"C-Ext",
"C-Man",
"C-Opt",
"C-PEP",
"C-PEP-Info",
"Cache-Control",
"Cache-Status",
"Cal-Managed-ID",
"CalDAV-Timezones",
"Capsule-Protocol",
"CDN-Cache-Control",
"CDN-Loop",
"Cert-Not-After",
"Cert-Not-Before",
"Clear-Site-Data",
"Client-Cert",
"Client-Cert-Chain",
"Close",
"Configuration-Context",
"Connection",
"Content-Base",
"Content-Digest",
"Content-Disposition",
"Content-Encoding",
"Content-ID",
"Content-Language",
"Content-Length",
"Content-Location",
"Content-MD5",
"Content-Range",
"Content-Script-Type",
"Content-Security-Policy",
"Content-Security-Policy-Report-Only",
"Content-Style-Type",
"Content-Type",
"Content-Version",
"Cookie",
"Cookie2",
"Cross-Origin-Embedder-Policy",
"Cross-Origin-Embedder-Policy-Report-Only",
"Cross-Origin-Opener-Policy",
"Cross-Origin-Opener-Policy-Report-Only",
"Cross-Origin-Resource-Policy",
"DASL",
"Date",
"DAV",
"Default-Style",
"Delta-Base",
"Depth",
"Derived-From",
"Destination",
"Differential-ID",
"Digest",
"DPoP",
"DPoP-Nonce",
"Early-Data",
"EDIINT-Features",
"ETag",
"Expect",
"Expect-CT",
"Expires",
"Ext",
"Forwarded",
"From",
"GetProfile",
"Hobareg",
"Host",
"HTTP2-Settings",
"If",
"If-Match",
"If-Modified-Since",
"If-None-Match",
"If-Range",
"If-Schedule-Tag-Match",
"If-Unmodified-Since",
"IM",
"Include-Referred-Token-Binding-ID",
"Isolation",
"Keep-Alive",
"Label",
"Last-Event-ID",
"Last-Modified",
"Link",
"Link-Template",
"Location",
"Lock-Token",
"Man",
"Max-Forwards",
"Memento-Datetime",
"Meter",
"Method-Check",
"Method-Check-Expires",
"MIME-Version",
"Negotiate",
"NEL",
"OData-EntityId",
"OData-Isolation",
"OData-MaxVersion",
"OData-Version",
"Opt",
"Optional-WWW-Authenticate",
"Ordering-Type",
"Origin",
"Origin-Agent-Cluster",
"OSCORE",
"OSLC-Core-Version",
"Overwrite",
"P3P",
"PEP",
"PEP-Info",
"Permissions-Policy",
"PICS-Label",
"Ping-From",
"Ping-To",
"Position",
"Pragma",
"Prefer",
"Preference-Applied",
"Priority",
"ProfileObject",
"Protocol",
"Protocol-Info",
"Protocol-Query",
"Protocol-Request",
"Proxy-Authenticate",
"Proxy-Authentication-Info",
"Proxy-Authorization",
"Proxy-Features",
"Proxy-Instruction",
"Proxy-Status",
"Public",
"Public-Key-Pins",
"Public-Key-Pins-Report-Only",
"Range",
"Redirect-Ref",
"Referer",
"Referer-Root",
"Refresh",
"Repeatability-Client-ID",
"Repeatability-First-Sent",
"Repeatability-Request-ID",
"Repeatability-Result",
"Replay-Nonce",
"Reporting-Endpoints",
"Repr-Digest",
"Retry-After",
"Safe",
"Schedule-Reply",
"Schedule-Tag",
"Sec-GPC",
"Sec-Purpose",
"Sec-Token-Binding",
"Sec-WebSocket-Accept",
"Sec-WebSocket-Extensions",
"Sec-WebSocket-Key",
"Sec-WebSocket-Protocol",
"Sec-WebSocket-Version",
"Security-Scheme",
"Server",
"Server-Timing",
"Set-Cookie",
"Set-Cookie2",
"SetProfile",
"Signature",
"Signature-Input",
"SLUG",
"SoapAction",
"Status-URI",
"Strict-Transport-Security",
"Sunset",
"Surrogate-Capability",
"Surrogate-Control",
"TCN",
"TE",
"Timeout",
"Timing-Allow-Origin",
"Topic",
"Traceparent",
"Tracestate",
"Trailer",
"Transfer-Encoding",
"TTL",
"Upgrade",
"Urgency",
"URI",
"User-Agent",
"Variant-Vary",
"Vary",
"Via",
"Want-Content-Digest",
"Want-Digest",
"Want-Repr-Digest",
"Warning",
"WWW-Authenticate",
"X-Content-Type-Options",
"X-Frame-Options",
/* begin experimental https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ */
"Sec-CH-UA",
"Sec-CH-UA-Arch",
"Sec-CH-UA-Bitness",
"Sec-CH-UA-Full-Version",
"Sec-CH-UA-Full-Version-List",
"Sec-CH-UA-Mobile",
"Sec-CH-UA-Model",
"Sec-CH-UA-Platform",
"Sec-CH-UA-Platform-Version",
"Sec-GPC",
"Attribution-Reporting-Eligible",
"Attribution-Reporting-Register-SourceExperimental",
"Attribution-Reporting-Register-Trigger",
"Content-Digest",
"Content-DPR",
"Critical-CHExperimental",
"Digest",
"DNT",
"Downlink",
"DPR",
"Early-Data",
"ECT",
"Large-Allocation",
"NEL",
"No-Vary-Search",
// "Observe-Browsing-Topics",
"Origin-Agent-Cluster",
"Repr-Digest",
"RTT",
"Save-Data",
"Sec-Browsing-Topics",
"Sec-CH-Prefers-Color-Scheme",
"Sec-CH-Prefers-Reduced-Motion",
"Set-Login",
"Speculation-Rules",
"Supports-Loading-Mode",
"Tk",
"Viewport-Width",
"Want-Content-Digest",
"Want-Content-Digest",
"Want-Digest",
"Want-Repr-Digest",
"Warning",
"Width",
"X-DNS-Prefetch-Control",
"X-Forwarded-For",
"X-Forwarded-Host",
"X-Forwarded-Proto",
"X-XSS-Protection",
/* end experimental */
] as const);
export const StandardHttpHeaderNamesLowerCase = new Set(
	[...StandardHttpHeaderNamesMixedCase].map( h => h.toLowerCase() )
);